import { registerPlugin } from "@capacitor/core";

import { isNativeIOS } from "./runtime";

const NativeCalendar = registerPlugin("NativeCalendar");

export async function presentNativeAppleCalendarEvent(eventData = {}) {
  if (!isNativeIOS()) return false;

  const startMs = eventData?.start instanceof Date
    ? eventData.start.getTime()
    : Number(eventData?.startMs);
  const endMs = eventData?.end instanceof Date
    ? eventData.end.getTime()
    : Number(eventData?.endMs);

  if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs <= startMs) {
    return false;
  }

  await NativeCalendar.presentEvent({
    title: String(eventData?.title || ""),
    notes: String(eventData?.details || ""),
    location: String(eventData?.location || ""),
    startMs,
    endMs,
  });
  return true;
}
